import { render, staticRenderFns } from "./ThePaymentDataTable.vue?vue&type=template&id=0645d23f&scoped=true"
import script from "./ThePaymentDataTable.vue?vue&type=script&lang=js"
export * from "./ThePaymentDataTable.vue?vue&type=script&lang=js"
import style0 from "./ThePaymentDataTable.vue?vue&type=style&index=0&id=0645d23f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645d23f",
  null
  
)

export default component.exports